import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateParagraphAttachmentsMutationVariables = Types.Exact<{
  input: Types.UpdateParagraphAttachmentsInput;
}>;


export type UpdateParagraphAttachmentsMutation = { __typename?: 'Mutation', updateParagraphAttachments: { __typename?: 'ParagraphAttachmentsPayload', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', id: string, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null }> } | null } };


export const UpdateParagraphAttachmentsDocument = gql`
    mutation UpdateParagraphAttachments($input: UpdateParagraphAttachmentsInput!) {
  updateParagraphAttachments(input: $input) {
    regulatoryDocument {
      id
      paragraphs {
        id
        attachments {
          ...AttachmentFields
        }
      }
    }
  }
}
    ${AttachmentFieldsFragmentDoc}`;
export type UpdateParagraphAttachmentsMutationFn = Apollo.MutationFunction<UpdateParagraphAttachmentsMutation, UpdateParagraphAttachmentsMutationVariables>;

/**
 * __useUpdateParagraphAttachmentsMutation__
 *
 * To run a mutation, you first call `useUpdateParagraphAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParagraphAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParagraphAttachmentsMutation, { data, loading, error }] = useUpdateParagraphAttachmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateParagraphAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParagraphAttachmentsMutation, UpdateParagraphAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParagraphAttachmentsMutation, UpdateParagraphAttachmentsMutationVariables>(UpdateParagraphAttachmentsDocument, options);
      }
export type UpdateParagraphAttachmentsMutationHookResult = ReturnType<typeof useUpdateParagraphAttachmentsMutation>;
export type UpdateParagraphAttachmentsMutationResult = Apollo.MutationResult<UpdateParagraphAttachmentsMutation>;
export type UpdateParagraphAttachmentsMutationOptions = Apollo.BaseMutationOptions<UpdateParagraphAttachmentsMutation, UpdateParagraphAttachmentsMutationVariables>;